import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import { debounce } from 'lodash';
import { toast } from "react-toastify";
import './UserAutoCompleteInput.css';
import { getActiveUsers } from '../../services/usuarios';

const UserAutocompleteInput = ({ onChange, value, placeholder,
    delegacionId,
    isInternalAgent,
    isSuperAdmin,
    isCallAgent,
 }) => {
    const [inputValue, setInputValue] = useState('');
    const [selectedOption, setSelectedOption] = useState(value);
    const [allUsers, setAllUsers] = useState([]);

    useEffect(() => {
        const loadAllUsers = async () => {
            try {
                const users = await getActiveUsers();
                const userOptions = users.filter(user => {
                    if (!user.erp_user_id) return false;
                    //agente interno ve misma delegacion
                    if (isSuperAdmin) {
                        return true;
                    }
                    if (isInternalAgent) {
                        return (
                            user.is_internal_agent === true &&
                            user.delegacion === delegacionId
                        );
                    }
                    if (isCallAgent) {
                        return (
                            user.is_call_agent === true &&
                            user.delegacion === delegacionId
                        );
                    }
                    return false;
                })
                .map(user => ({
                    value: user.erp_user_id,
                    label: user.name,
                }));
                userOptions.unshift({
                    value: 'all',
                    label: 'Ver todos los usuarios',
                });
                setAllUsers(userOptions);
            } catch (error) {
                toast.error('Error al cargar los usuarios', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: false,
                });
            }
        };

        loadAllUsers();
    }, []);

    // Sync selectedOption when value prop changes (e.g., from URL params)
    useEffect(() => {
        if (value && allUsers.length > 0) {
            // If value is a string (user ID or 'all'), find the matching option
            if (typeof value === 'string') {
                const matchingOption = allUsers.find(user => user.value === value);
                if (matchingOption) {
                    setSelectedOption(matchingOption);
                }
            } else {
                // If value is already an object, use it directly
                setSelectedOption(value);
            }
        } else if (value === null) {
            setSelectedOption(null);
        }
    }, [value, allUsers]);

    const loadOptions = debounce(async (inputValue, callback) => {
        if (!inputValue || inputValue.length === 0) {
            return callback(allUsers);
        }

        const filteredUsers = allUsers.filter(user =>
            user.label.toLowerCase().includes(inputValue.toLowerCase())
        );

        callback(filteredUsers);
    }, 300);

    const handleChange = (selectedOption) => {
        setSelectedOption(selectedOption);
        onChange(selectedOption);
    };

    return (
        <div className="row mb-4 mt-0 d-flex justify-content-center align-items-center">
            <div className="col-md-3" style={{ textAlign: 'right' }}>
                Seleccionar usuario:
            </div>
            <div className="col-md-5 ml-auto">
                <AsyncSelect
                    cacheOptions
                    loadOptions={loadOptions}
                    onInputChange={setInputValue}
                    onChange={handleChange}
                    value={selectedOption}
                    placeholder={placeholder}
                    inputValue={inputValue}
                    defaultOptions={allUsers}
                    className="user-select-container"
                    classNamePrefix="user-select"
                />
            </div>
        </div>
    );
};

UserAutocompleteInput.propTypes = {
    value: PropTypes.object,
    placeholder: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    delegacionId: PropTypes.string,
    isInternalAgent: PropTypes.bool,
    isSuperAdmin: PropTypes.bool,
    isCallAgent: PropTypes.bool
};

export default UserAutocompleteInput;